import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/Header';

function EditTransaction() {
  const { id } = useParams(); // Get the transaction ID from URL
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    amount: '',
    transaction_date: '',
    payment_type: '',
    check_number: '',
    description: '',
    currency_type: '',
    cash_in_type: '',
    file: null,
  });
  
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [existingFile, setExistingFile] = useState('');
  const [userCurrency, setUserCurrency] = useState('');

  // Fetch user profile to get allowed currency
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const response = await axios.get('http://localhost:7000/user/profile', {
          headers: { Authorization: `Bearer ${token}` },
        });

        setUserCurrency(response.data.currency);
      } catch (err) {
        setError('Failed to fetch user profile.');
      }
    };

    fetchUserProfile();
  }, []);

  // Fetch transaction data
  useEffect(() => {
    const fetchTransaction = async () => {
      try {
        const token = localStorage.getItem('accessToken');
        const response = await axios.get(`http://localhost:7000/user/getTransaction/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const transaction = response.data.transaction;

        // Format transaction_date correctly
        let formattedDate = '';
        if (transaction.transaction_date) {
          const dateObj = new Date(transaction.transaction_date);
          formattedDate = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, '0')}-${String(dateObj.getDate()).padStart(2, '0')}`;
        }

        setFormData({
          ...transaction,
          transaction_date: formattedDate,
          file: null, // Reset file input
        });

        if (transaction.file) {
          setExistingFile(transaction.file);
        }
      } catch (err) {
        setError('Failed to load transaction data.');
      }
    };

    fetchTransaction();
  }, [id]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setFormData({
        ...formData,
        file: files[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    try {
      const token = localStorage.getItem('accessToken');
      const updatedFormData = new FormData();
      updatedFormData.append('amount', formData.amount);
      updatedFormData.append('transaction_date', formData.transaction_date);
      updatedFormData.append('payment_type', formData.payment_type);
      updatedFormData.append('check_number', formData.payment_type === 'cheque' ? formData.check_number : '');
      updatedFormData.append('description', formData.description);
      updatedFormData.append('currency_type', formData.currency_type);
      updatedFormData.append('cash_in_type', formData.cash_in_type);

      if (formData.file) {
        updatedFormData.append('file', formData.file);
      }

      await axios.put(`http://localhost:7000/user/updateTransaction/${id}`, updatedFormData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      setMessage('Transaction updated successfully.');
      alert('Transaction updated successfully.');
      setTimeout(() => navigate('/user/home'), 1000);
    } catch (err) {
      setError('Failed to update transaction.');
    }
  };

  return (
    <div>
      {/* Navbar */}
      <Header />
      
      <div className="container mt-5">
        <h2 className="text-center mb-4">Edit Transaction</h2>
        {message && <div className="alert alert-success">{message}</div>}
        {error && <div className="alert alert-danger">{error}</div>}
        
        <form onSubmit={handleSubmit} className="card p-4 shadow" encType="multipart/form-data">
          <div className="mb-3">
            <label className="form-label">Payment Type</label>
            <select name="payment_type" className="form-select" value={formData.payment_type} onChange={handleChange} required>
              <option value="">Select Payment Type</option>
              <option value="cash">Cash</option>
              <option value="cheque">Cheque</option>
            </select>
          </div>

          {formData.payment_type === 'cheque' && (
            <div className="mb-3">
              <label className="form-label">Cheque Number</label>
              <input type="text" name="check_number" className="form-control" value={formData.check_number} onChange={handleChange} required maxLength="12" />
            </div>
          )}

          <div className="mb-3">
            <label className="form-label">Currency</label>
            <input type="text" className="form-control" value={userCurrency} readOnly disabled />
          </div>

          <div className="mb-3">
            <label className="form-label">Cash-in Type</label>
            <select name="cash_in_type" className="form-select" value={formData.cash_in_type} onChange={handleChange} required>
              <option value="">Select Cash-in Type</option>
              <option value="counter_cash">Counter Cash</option>
              <option value="service">Service</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Amount</label>
            <input type="number" name="amount" className="form-control" value={formData.amount} onChange={handleChange} required />
          </div>

          <div className="mb-3">
            <label className="form-label">Transaction Date</label>
            <input type="date" name="transaction_date" className="form-control" value={formData.transaction_date} onChange={handleChange} required />
          </div>

          <div className="mb-3">
            <label className="form-label">Description</label>
            <textarea name="description" className="form-control" rows="3" value={formData.description} onChange={handleChange}></textarea>
          </div>

          <div className="mb-3">
            <label className="form-label">Upload Image or PDF</label>
            <input type="file" name="file" className="form-control" onChange={handleChange} accept="image/*, application/pdf" />
            {existingFile && <div className="mt-2"><a href={existingFile} target="_blank" rel="noopener noreferrer">View current file</a></div>}
          </div>

          <button type="submit" className="btn btn-primary w-100">Update Transaction</button>
        </form>
      </div>
    </div>
  );
}

export default EditTransaction;
